<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    custom-class="paylink-modal"
    width="440px"
  >
    <div class="pl-content">
      <button type="button" class="pl-close" @click.stop="onDialogClose">
        <i class="el-icon-close"></i>
      </button>

      <div class="pl-icon">
        <i class="el-icon-link"></i>
      </div>

      <h3 class="pl-title">Link de pago</h3>
      <p class="pl-subtitle">
        Copia y comparte este enlace para recibir tu pago de forma segura.
      </p>

      <div class="pl-link-box" @click.stop="copyURL">
        <input class="pl-link-input" :value="link" readonly />
        <button type="button" class="pl-copy-btn">
          <i
            :class="isLinkCopied ? 'el-icon-check' : 'el-icon-document-copy'"
          ></i>
          {{ isLinkCopied ? "Copiado" : "Copiar" }}
        </button>
      </div>

      <div class="pl-divider">
        <span>o</span>
      </div>

      <button type="button" class="pl-whatsapp-btn" @click.stop="openURL">
        <i class="el-icon-chat-dot-round"></i>
        Compartir por WhatsApp
      </button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "WrapperPaymentLink",
  data() {
    return {
      dialogVisible: this.showDialog,
      infoPaymentLink: null,
      isLinkCopied: false
    };
  },
  computed: {
    link() {
      if (!this.paymentLink) return "";
      return (
        this.paymentLink.link ||
        this.paymentLink.url ||
        this.paymentLink.payment_url ||
        (typeof this.paymentLink === "string" ? this.paymentLink : "") ||
        ""
      );
    }
  },
  watch: {
    showDialog(v) {
      this.dialogVisible = v;
    },
    paymentLink(v) {
      this.infoPaymentLink = v;
    }
  },
  methods: {
    onDialogClose() {
      this.isLinkCopied = false;
      this.$emit("onDialogClose");
    },
    async copyURL() {
      if (!this.link) {
        this.$notifications.error({ message: "No hay enlace disponible" });
        return;
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.link);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = this.link;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$notifications.success({
          message: "Enlace de pago copiado"
        });
        this.isLinkCopied = true;
      } catch (e) {
        this.$notifications.error({
          message: "No se pudo copiar el enlace"
        });
      }
    },
    async openURL() {
      try {
        const text = `¡Hola!, te comparto el link de pago en donde puedes realizarlo de manera rápida y segura haciendo clic en el siguiente enlace: \n${this.link}`;
        const textURI = `https://api.whatsapp.com/send?text=${encodeURI(text)}`;
        window.open(textURI, "_blank");
      } catch (e) {
        return false;
      }
    }
  },
  props: {
    paymentLink: {
      type: Object,
      default: () => ({})
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.pl-content {
  padding: 32px 28px;
  text-align: center;
  position: relative;
}

.pl-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: #f0f2f7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
  i {
    font-size: 16px;
    color: #31355c;
    font-weight: 700;
  }
  &:hover {
    background: #e4e8f0;
  }
}

.pl-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f0fdf9 0%, #e0f7f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  i {
    font-size: 22px;
    color: #1d9e75;
  }
}

.pl-title {
  font-size: 18px;
  font-weight: 700;
  color: #2d2b55;
  margin: 0 0 6px;
}

.pl-subtitle {
  font-size: 13px;
  color: #909399;
  margin: 0 0 20px;
  line-height: 1.5;
}

.pl-link-box {
  display: flex;
  align-items: center;
  border: 1.5px solid #e4eaf6;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s;
  &:hover {
    border-color: #3fdbbf;
  }
}

.pl-link-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 14px;
  font-size: 13px;
  color: #606266;
  background: transparent;
  cursor: pointer;
  min-width: 0;
  text-overflow: ellipsis;
}

.pl-copy-btn {
  border: none;
  background: #f7f8fa;
  color: #31355c;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  transition: background 0.12s;
  &:hover {
    background: #eef0f5;
  }
}

.pl-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
  span {
    font-size: 12px;
    color: #c0c4cc;
  }
  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e4eaf6;
  }
}

.pl-whatsapp-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border: 1.5px solid #25d366;
  border-radius: 10px;
  background: transparent;
  color: #25d366;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  &:hover {
    background: #25d366;
    color: #fff;
  }
}
</style>

<style lang="scss">
.paylink-modal {
  border-radius: 16px !important;
  .el-dialog__header {
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
